var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { MultiselectButton, MultiselectSelectedItem, } from './MultiselectButton.js';
import { useMultiselect } from './MultiselectContext.js';
export const MultiselectCreatableButton = props => {
    const { children } = props, rest = __rest(props, ["children"]);
    const { selectedItems } = useMultiselect();
    return (React.createElement(MultiselectButton, Object.assign({}, rest), selectedItems.map((item, index) => (React.createElement(MultiselectSelectedItem, { key: index, value: item, index: index }, item)))));
};
//# sourceMappingURL=MultiselectCreatableButton.js.map